import { __, includes, compose, filter, not } from 'ramda';

import { selectContentType } from '../../../lib/contentful/selectors';

const floatingContentTypes = ['hubResponsiveHeroImage'];

const isFloatingComponent = compose(
  includes(__, floatingContentTypes),
  selectContentType
);

export const filterGridComponents = filter(compose(not, isFloatingComponent));
export const filterFloatingComponents = filter(isFloatingComponent);
